import React, { useState, useEffect, useRef } from 'react';
import {  Home,  Settings,  Users } from 'react-feather';
import {  NavLink, useLocation } from 'react-router-dom';


function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const { pathname } = location;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarExpanded, setSidebarExpanded] = useState(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true');

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return;
      setSidebarOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded);
    if (sidebarExpanded) {
      document.querySelector('body').classList.add('sidebar-expanded');
    } else {
      document.querySelector('body').classList.remove('sidebar-expanded');
    }
  }, [sidebarExpanded]);

  return (
    <div>
      {/* Sidebar backdrop (mobile only) */}
      <div
        className={`fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
          sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        aria-hidden="true"
      ></div>

      {/* Sidebar */}
      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col m-2 mb-8  top-0 rounded-2xl absolute z-40 left-0  lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 lg:w-48 lg:sidebar-expanded:!w-64 2xl:!w-64 shrink-0 bg-slate-800 p-4 transition-all duration-200 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-72'
        }`}
      >
        {/* Sidebar header */}
        <div className="flex justify-between mb-10 pr-3 sm:px-2">
          {/* Close button */}
          <button
            ref={trigger}
            className="lg:hidden text-slate-500 hover:text-slate-400"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}
          >
            <span className="sr-only">Close sidebar</span>
            <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
            </svg>
          </button>
          {/* Logo */}
          <NavLink end to="/dashboard" className="block">
            <div className='flex items-center'>
             <img src="/ShruckenLogo.png" className="h-8 mr-1" alt="Shrucken-Logo" />
             <h1 className='text-white font-bold text-3xl'>SCMS</h1>
            </div>

          </NavLink>
        </div>


                {/* Links */}
                <div className="space-y-8">
          {/* Pages group */}
          <div>
            <h3 className="text-xs uppercase text-slate-500 font-semibold pl-3">
              <span className="hidden lg:hidden lg:sidebar-expanded:hidden 2xl:hidden text-center w-6" aria-hidden="true">
                •••
              </span>
              <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">Menu</span>
            </h3>


            <ul className="mt-3 space-y-2">

            <li className={`px-3 py-2 rounded-lg hover:bg-slate-900 mb-2 last:mb-0 ${pathname.includes('/dashboard') && 'bg-slate-900 rounded-xl'}`}>
                <NavLink
                  end
                  to="/dashboard"
                  className={`block text-slate-50 hover:text-white truncate transition duration-150 ${
                    pathname.includes('/dashboard') && 'hover:text-slate-50'
                  }`}
                >
                  <div className="flex items-center">
                    <Home size='16px' />
                    <span className="text-base font-medium ml-3 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">Dashboard</span>
                  </div>
                </NavLink>
              </li>

              {/* Master */}
              {/* <SidebarLinkGroup activecondition={pathname === '/property' || pathname === '/meters'  }>
                {(handleClick, open) => {
                  return (
                    <React.Fragment>
                      <a
                        href="#0"
                        className={`block text-slate-200 hover:text-white truncate transition duration-150 ${
                          (pathname === '/property' || pathname.includes('property')) && 'hover:text-slate-200'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          sidebarExpanded ? handleClick() : setSidebarExpanded(true);
                        }}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <Layers size='16px'/>
                            <span className="text-base font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                              Master
                            </span>
                          </div>

                          <div className="flex shrink-0 ml-2">
                            <svg className={`w-3 h-3 shrink-0 ml-1 fill-current text-slate-400 ${open && 'rotate-180'}`} viewBox="0 0 12 12">
                              <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                            </svg>
                          </div>
                        </div>
                      </a>
                      <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                        <ul className={`pl-9 mt-1 ${!open && 'hidden'}`}>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/property"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 hover:translate-x-2 transition duration-150 truncate ' + (isActive ? '!text-indigo-500 ' : '')
                              }
                            >
                              <span className="text-base font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Property Master
                              </span>
                            </NavLink>
                          </li>
                          <li className="mb-1 last:mb-0">
                            <NavLink
                              end
                              to="/meters"
                              className={({ isActive }) =>
                                'block text-slate-400 hover:text-slate-200 hover:translate-x-2 transition duration-150 truncate ' + (isActive ? '!text-indigo-500 ' : '')
                              }                            >
                              <span className="text-base font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Meter Master
                              </span>
                            </NavLink>
                          </li>

                        </ul>
                      </div>
                    </React.Fragment>
                  );
                }}
              </SidebarLinkGroup> */}



              
              <li className={`px-3 py-2 rounded-lg hover:bg-slate-900 mb-2 last:mb-0 ${pathname.includes('/customers') && 'bg-slate-900 rounded-xl'}`}>
                <NavLink
                  end
                  to="/customers"
                  className={`block text-slate-50 hover:text-white truncate transition duration-150 ${
                    pathname.includes('/customers') && 'hover:text-slate-50'
                  }`}
                >
                  <div className="flex items-center">
                    <Users size='16px' />
                    <span className="text-base font-medium ml-3  lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">Customers</span>
                  </div>
                </NavLink>
              </li>

              <li className={`px-3 py-2 rounded-lg hover:bg-slate-900 mb-2 last:mb-0 ${pathname.includes('/settings') && 'bg-slate-900 rounded-xl'}`}>
                <NavLink
                  end
                  to="/settings"
                  className={`block text-slate-50 hover:text-white truncate transition duration-150 ${
                    pathname.includes('/settings') && 'hover:text-slate-50'
                  }`}
                >
                  <div className="flex items-center">
                    <Settings size='16px' />
                    <span className="text-base font-medium ml-3  lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">Settings</span>
                  </div>
                </NavLink>
              </li>


            </ul>
          </div>

        </div>



        {/* Expand / collapse button */}
        <div className="pt-3 hidden lg:hidden 2xl:hidden justify-end mt-auto">
          <div className="px-3 py-2">
            <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
              <span className="sr-only">Expand / collapse sidebar</span>
              <svg className="w-6 h-6 fill-current sidebar-expanded:rotate-180" viewBox="0 0 24 24">
                <path className="text-slate-400" d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z" />
                <path className="text-slate-600" d="M3 23H1V1h2z" />
              </svg>
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Sidebar;